import * as types from './mutations-types'

export default {
  [types.setSubscribePlans] (state, subscribePlans) {
    state.subscribePlans = subscribePlans
  },
  [types.setChosenPlan] (state, chosenPlan) {
    state.chosenPlan = chosenPlan
  },
  [types.setBasicSeller] (state, basicSeller) {
    state.basicSeller = basicSeller
    if (basicSeller !== '') {
      window.localStorage.setItem('basicSeller', JSON.stringify(state.basicSeller))
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/subscribe/vuex/mutations.js